function showLightboxOnce() {
    const lightbox = document.getElementById('lightbox');
    const closeButton = document.getElementById('close-lightbox');

    if (localStorage.getItem('lightboxShown') !== 'true') {
        // Show the lightbox after a short delay
        setTimeout(() => {
            lightbox.style.display = 'flex';
        }, 500);

        // Mark the lightbox as shown
        localStorage.setItem('lightboxShown', 'true');
    }

    // Close lightbox functionality
    closeButton.addEventListener('click', function() {
        lightbox.style.display = 'none';
    });

    // Optional: Close the lightbox when clicking outside the content area
    lightbox.addEventListener('click', function(event) {
        if (event.target === lightbox) {
            lightbox.style.display = 'none';
        }
    });
}

// Call the function on page load
document.addEventListener('DOMContentLoaded', showLightboxOnce);